import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Iconic 39-storey towers with panoramic city views",
    "Expansive rooftop skywalk, 400 feet above ground",
    "Over 100+ world-class lifestyle and wellness amenities",
    "22,000 sq. ft. resident's clubhouse with indulgences",
  ];
  const highlights2 = [
    "Retail spaces within the community for added convenience",
    "Excellent connectivity via road, rail, mono and metro",
    "Next to Eastern Freeway, BKC and major hospitals",
    "Dedicated pet park and corner for furry companions",
  ];
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          {project} - Overview
        </h1>

        <p>
          Experience elevated living at Siddha Sky Sion NX - Altaire Collection
          (Tower 3) by SiDDHA | SEJAL Realty. Soaring 39 storeys high with
          exclusive residences, world-class amenities, and Mumbai’s first-ever
          Skywalk, this landmark address blends luxury, spirituality, and
          seamless connectivity. With thoughtfully designed 2 & 3 BHK homes,
          panoramic views, and an iconic lifestyle, Siddha Sky redefines urban
          living in the heart of the city.
          <br />
          <b> Siddha Sky - Where your lifestyle meets new heights.</b>
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy text-capitalize">
              <li>
                <span>Spacious 1 & 2 BHK Residences</span>
              </li>
              <li>
                <span>
                  Iconic high-rise 46-Storey Towers with premium architecture
                </span>
              </li>
              <li>
                <span>
                  Unmatched Investment Potential with high appreciation value
                </span>
              </li>
            </ul> */}

            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy">
              <li>
                <span>Smart layouts for modern families</span>
              </li>
              <li>
                <span>
                  Seamless Connectivity to EEH, Railway Station & Malls
                </span>
              </li>
              <li>
                <span>
                  Marvellous Amenities like Clubhouse, Swimming Pool & More
                </span>
              </li>
            </ul> */}
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
